import { McbGridComponent } from './mcb-grid.component';
import { McbGridCellComponent } from './mcb-grid-cell/mcb-grid-cell.component';
import { McbGridSearchComponent } from './mcb-grid-search/mcb-grid-search.component';
import { McbGridSearchInComponent } from './mcb-grid-search/mcb-grid-search-in.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonInfrastructureModule } from '../../../infra/common/common-infrastructure.module';
import { GridModule } from '@progress/kendo-angular-grid';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { FormGroupModule } from '../form-group/form-group.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { MCBGridSearchDirective } from './mcb-grid-search.directive';

@NgModule({
  declarations: [
    McbGridComponent,
    McbGridCellComponent,
    McbGridSearchComponent,
    McbGridSearchInComponent,
    MCBGridSearchDirective
  ],
  imports: [
    NgbModule,
    CommonModule,
    CommonInfrastructureModule,
    FormGroupModule,
    GridModule,
    TooltipModule,
    ToolBarModule,
    DropDownsModule,
    ButtonsModule
  ],
  exports: [
    McbGridComponent,
    McbGridCellComponent,
    McbGridSearchComponent,
    McbGridSearchInComponent,
    MCBGridSearchDirective
  ]
})
export class McbGridModule {
}
